import { api } from './index';

const BASE_PATH = '/api/internal/skills';

export type Skill = {
  id: number;
  name: string;
  career: string;
  humanCareer: string;
};

export const skillsApi = {
  index(career?: string): Promise<Skill[]> {
    return api({
      method: 'get',
      url: career ? `${BASE_PATH}?career=${career}` : BASE_PATH,
    }).then(response => response.data.skills);
  },
};
